module.exports = __webpack_public_path__ + "img/360-produktion-pos-2.67941b80.jpg";